import { render, staticRenderFns } from "./CustomerCorporateChangeStatus.vue?vue&type=template&id=de6a71a4&scoped=true"
import script from "./CustomerCorporateChangeStatus.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateChangeStatus.vue?vue&type=style&index=0&id=de6a71a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6a71a4",
  null
  
)

export default component.exports